<div class="login">
  <div class="row">
    <div class="col-12 offset-sm-2 col-sm-8 offset-md-3 col-md-6 py-3">
      <form (ngSubmit)="onUserLoginSubmit()">
        <div>
          <label for="username">Email Address</label>
          <input type="email" class="form-control large" [(ngModel)]="username" name="username" autocapitalize="none" autocomplete="username" autofocus>
        </div>
        <div class="mt-3">
          <label for="password">Password</label>
          <input type="password" class="form-control large" [(ngModel)]="password" name="password" autocomplete="password">
        </div>
        <div class="mt-2">
          <div class="form-check">
            <label class="form-check-label">
            <input class="form-check-input" type="checkbox" [(ngModel)]="remember" name="remember">
            <span>Remember Me</span>
          </label>
          <a textCta="light" class="float-right forgot-pw-link" [routerLink]="['/forgot-password']">Forgot Password?</a>
        </div>
      </div>
        <div class="login-button-wrapper">
          <button id="login-button" type="submit" class="btn btn-primary">Log In</button>
        </div>
        <div class="text-right text-sm-center mt-3">
          <a textCta="light" class="no-login-link" [routerLink]="['/questionnaire']">Don't have a login?</a>
        </div>
      </form>
    </div>
  </div>
</div>
